import React, { useState } from 'react';
import { User } from 'lucide-react';

export function ProfilePhoto({ photoUrl, name, size = 40, className = "" }) {
  const [imageError, setImageError] = useState(false);
  const initials = name ? name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : '?';
  
  // Default avatar colors
  const bgColors = ['#3B82F6', '#10B981', '#8B5CF6', '#F59E0B', '#EF4444', '#EC4899'];
  const colorIndex = name ? name.charCodeAt(0) % bgColors.length : 0;
  
  if (photoUrl && !imageError) {
    return (
      <img 
        src={photoUrl} 
        alt={name || 'Profile'} 
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
        onError={() => setImageError(true)}
      />
    );
  }
  
  // Default avatar with initials
  return (
    <div 
      className={`rounded-full flex items-center justify-center font-medium text-white ${className}`}
      style={{ 
        width: size, 
        height: size, 
        backgroundColor: bgColors[colorIndex],
        fontSize: size * 0.4
      }}
    >
      {initials}
    </div>
  );
}

export default ProfilePhoto;
